import React from 'react';
import { Typography } from '@mui/material';

interface EmptyStateBlockProps {
  img: string;
  text: string;
}

export const EmptyStateBlock = (
  {
    img,
    text,
  } : EmptyStateBlockProps) => {
  return (
    <>
      <img
        src={img}
        style={{
          height: 125,
          objectFit: 'contain',
          marginTop: '256px',
          marginBottom: '32px',
        }}
      />
      <Typography sx={{
        fontSize: '14px',
        fontWeight: 400,
        color: '#828282',
        textAlign: 'center',
      }}>
        {text}
      </Typography>
    </>
  );
}
